import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-111f05b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fd-header" }
const _hoisted_2 = { class: "fd-header-tp-box fd-header-tp-pd" }
const _hoisted_3 = { class: "fd-header-tp-box-reg" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { style: {"text-align":"center"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 消息")
const _hoisted_7 = { class: "fd-header-tp-box-reg-tips" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { style: {"text-align":"center"} }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 报名/关注")
const _hoisted_11 = { class: "fd-header-tp-box-reg-tips" }
const _hoisted_12 = { class: "el-dropdown-link" }
const _hoisted_13 = { style: {"color":"#FFFFFF"} }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("财务管理")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("会员中心")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("退出登录")
const _hoisted_17 = {
  key: 2,
  class: "fd-header-tp-box-x"
}
const _hoisted_18 = {
  key: 0,
  style: {"font-size":"12px","background-color":"#fff","color":"#db7c12"}
}
const _hoisted_19 = { class: "fd-center fd-header-bt-box" }

import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import tool from "@/utils/tool";
import router from "@/router/index";
import {  ArrowDown, Avatar, BellFilled, Message  } from '@element-plus/icons-vue'
import Property from '@/views/middleGround/member/property.vue'
import CommunityBusinesses from '@/views/middleGround/member/communityBusinesses.vue'
import BrandManufacturers from '@/views/middleGround/member/brandManufacturers.vue'
import { defineComponent } from "vue";
import { shallowReactive } from "vue";

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {


const ustore = useStore();
    var bindData = shallowReactive({
        loginMember: ustore.state.loginMember==undefined ? {} : ustore.state.loginMember,
        isLogin: ustore.state.loginMember==undefined ? false : true,
        newsNotReadCount: 0,
        applyNotReadCount: 0,
    });
    if(ustore.state.loginMember==undefined){
        store.dispatch("getMyInfo").then(
            (data) => {
            //成功
                bindData.loginMember = data.result;
                bindData.isLogin = ustore.state.loginMember==undefined ? false : true
            },
            (error) => {
            console.log("获取当前登录会员信息错误");
            }
        );
    }

    const handleLogin = () => {
        router.push('/frontDesk/login')
    }
    //打开新页面
    const openNewWindow = (path:any) => {
      const { href } = router.resolve({
                path: path
            });
            window.open(href, "_blank");
   }
    const gotoMemberCenterEvent = () => {
        openNewWindow('/middleGround/member/index')
    }

    const gotoMembershipFeesEvent = () => {
      openNewWindow('/middleGround/member/membershipFees');
    }

     const logoutEvent = () => {
         store.dispatch("memberLogout").then(
        (data) => {
          //成功
          router.push('/frontDesk/login')
        },
        (error) => {
          console.log(error.msg);
        }
      );
    }

    const tabs = reactive([
        {
            title: '首页',
            name: 0,
            path: '/frontDesk/index'
        },
        {
            title: '楼盘招商',
            name: 1,
            path: '/frontDesk/investIndex'
        },
        {
            title: '品牌厂家',
            name: 2,
            path: '/frontDesk/brandIndex'
        },
        {
            title: '社区营销',
            name: 3,
            path: '/frontDesk/bbsList'
        },
        {
            title: '拎包培训',
            name: 4,
            path: '/frontDesk/trainingIndex'
        },
        {
            title: '行业交流',
            name: 5,
            path: '/frontDesk/industryIndex'
        },
        {
            title: '新闻动态',
            name: 6,
            path: '/frontDesk/newsList'
        },
        {
            title: '拎包商加盟',
            name: 7,
            path: '/frontDesk/leagueIndex'
        },
        {
            title: '关于我们',
            name: 8,
            path: '/frontDesk/about'
        },
         {
            title: '人才招聘',
            name: 9,
            path: '/frontDesk/recruitment'
        },
        {
            title: '成为会员',
            name: 10,
            path: '/frontDesk/member'
        }
    ]);

    const activeIndex = ref(0)
    const handleTabsToggle = () => {
        router.push(tabs[activeIndex.value].path)
    }

    const currPath = router.currentRoute.value.path;
    const currIndex = tabs.findIndex((tab: any) => {
        return tab.path.length>0&&currPath.startsWith(tab.path);
    });

    if(currIndex>=0){
        activeIndex.value = currIndex;
    }

    const handleToRegister = () => {
       router.push('/frontDesk/register/all')
     }

if(bindData.isLogin) {
  store
    .dispatch('newsModule/pageRssActivityReadList', {
      curPage: 1,
      pageSize: 1,
      filtrate: {
        isRead: 'N',
        activityStatus: '',
        searchTime: '',
        keyword: '',
      },
    })
    .then(
      (data) => {
        //成功
        bindData.newsNotReadCount = data.totalCount;
      },
      (error) => {
        console.log(error.msg);
      }
    );

  store
    .dispatch('applyModule/pageActivityApplyReadList', {
      curPage: 1,
      pageSize: 1,
      filtrate: {
        isRead: 'N',
        auditStatus: '',
        searchTime: '',
        keyword: '',
      },
    })
    .then(
      (data) => {
        //成功
        for (var index in data.result) {
          const obj = data.result[index];
          if (!obj.rssCompanyLogo || obj.rssCompanyLogo.length <= 0) {
            obj.rssCompanyLogo = require('@/assets/no_pict.png');
          }
          if (!obj.activityThumbnailUrl || obj.activityThumbnailUrl.length <= 0) {
            obj.activityThumbnailUrl = require('@/assets/no_pict.png');
          }
          if (!obj.activityImgUrl || obj.activityImgUrl.length <= 0) {
            obj.activityImgUrl = require('@/assets/no_pict.png');
          }
        }
        bindData.applyNotReadCount = data.totalCount;
      },
      (error) => {
        console.log(error.msg);
      }
    );
}



return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "fd-header-tp" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_image, {
            class: "fd-header-tp-box-logo",
            src: require('@/assets/fd/index_logo.png')
          }, null, 8, ["src"]),
          _createVNode(_component_el_image, {
            class: "fd-header-tp-box-title",
            src: require('@/assets/fd/index_title.png')
          }, null, 8, ["src"]),
          _createElementVNode("div", _hoisted_3, [
            (_unref(bindData).isLogin && _unref(bindData).newsNotReadCount>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("table", null, [
                    _createElementVNode("tr", _hoisted_5, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Message))
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_6,
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(bindData).newsNotReadCount), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(bindData).isLogin && _unref(bindData).applyNotReadCount>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("table", null, [
                    _createElementVNode("tr", _hoisted_9, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(BellFilled))
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_10,
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(bindData).applyNotReadCount), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_unref(bindData).isLogin||_unref(tool).isNull(_unref(bindData).loginMember.avatarUrl))
              ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 2,
                  class: "fd-header-tp-box-avatar"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Avatar), {
                      color: "#015d87",
                      size: 30
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(bindData).isLogin&&_unref(tool).isNotNull(_unref(bindData).loginMember.avatarUrl))
              ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 3,
                  class: "fd-header-tp-box-icon",
                  src: _unref(bindData).loginMember.avatarUrl
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            _createElementVNode("table", null, [
              _createElementVNode("tr", null, [
                (_unref(bindData).isLogin)
                  ? (_openBlock(), _createBlock(_component_el_dropdown, { key: 0 }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            (_unref(bindData).loginMember.month<=2)
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 0,
                                  onClick: gotoMembershipFeesEvent
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_14
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_dropdown_item, { onClick: gotoMemberCenterEvent }, {
                              default: _withCtx(() => [
                                _hoisted_15
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_dropdown_item, {
                              divided: "",
                              onClick: logoutEvent
                            }, {
                              default: _withCtx(() => [
                                _hoisted_16
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_12, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(bindData).loginMember.name), 1),
                          _createVNode(_component_el_icon, {
                            class: "el-icon--right",
                            style: {"color":"#FFFFFF"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ArrowDown))
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_unref(bindData).isLogin)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      onClick: handleLogin
                    }, "登录"))
                  : _createCommentVNode("", true),
                (!_unref(bindData).isLogin)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, "|"))
                  : _createCommentVNode("", true),
                (!_unref(bindData).isLogin)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 3,
                      onClick: handleToRegister
                    }, "注册"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("tr", null, [
                (_unref(bindData).isLogin && _unref(bindData).loginMember.month<=2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, "请及时缴纳会员费"))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_container, { class: "fd-header-bt" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_el_tabs, {
            modelValue: activeIndex.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeIndex).value = $event)),
            onTabClick: handleTabsToggle
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (item) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: item.name,
                  label: item.title,
                  name: item.name
                }, null, 8, ["label", "name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})